const tranlations = {
	filter: {
		de: 'Filter',
		en: 'Filter'
	},
	openFilter: {
		de: 'Filter anzeigen',
		en: 'Show filter'
	},
	closeFilter: {
		de: 'Filter ausblenden',
		en: 'Hide filter'
	},
	open: {
		de: '\u00D6ffnen',
		en: 'Open'
	},
	close: {
		de: 'Schlie\u00DFen',
		en: 'Close'
	},
	search: {
		de: 'Suche',
		en: 'Search'
	},
	searchTerm: {
		de: 'Suchbegriff',
		en: 'search term'
	},
	resetSearch: {
		de: 'Suche zur\u00FCcksetzen',
		en: 'Reset search'
	},
	allMustApply: {
		de: 'Alle m\u00FCssen zutreffen',
		en: 'All must apply'
	},
	oneMustApply: {
		de: 'Eins muss zutreffen',
		en: 'one must apply'
	},
	before: {
		de: 'vor dem',
		en: 'before'
	},
	after: {
		de: 'nach dem',
		en: 'after'
	},
	directLink: {
		de: 'direkter Link',
		en: 'direct link'
	},
	all: {
		de: 'Alle',
		en: 'All'
	},
	showAll: {
		de: 'Alle anzeigen',
		en: 'Show all'
	},
	today: {
		de: 'Heute',
		en: 'today'
	},
	noresult: {
		de: 'Keine passenden Eintr\u00E4ge gefunden',
		en: 'No matching items found'
	},
	loading: {
		de: 'Lade...',
		en: 'Loading...'
	},
	results: {
		de: 'Einträge',
		en: 'entries'
	},
	copyClipboard: {
		de: 'Link in Zwischenablage kopieren',
		en: 'Copy link to clipboard'
	},
	sort: {
		de: 'Sortieren nach',
		en: 'Sort by'
	},
	Title: {
		de: 'Titel',
		en: 'Title'
	},
	asc: {
		de: 'aufst',
		en: 'asc'
	},
	desc: {
		de: 'abst',
		en: 'desc'
	},
	First: {
		de:	'Erste',
		en: 'First'
	},
	Previous: {
		de: 'Vorherige',
		en: 'Previous'
	},
	Next: {
		de: 'Naechste',
		en: 'Next'
	},
	Last: {
		de: 'Letzte',
		en: 'Last'
	},
	Page: {
		de: 'Seite',
		en: 'Page'
	},
	'show more': {
		de: 'Mehr anzeigen',
		en: 'Show more'
	},
	'show less': {
		de: 'Weniger anzeigen',
		en: 'Show less'
	}

};

export function getTranslation(key) {
	// get language from current html tag if present, otherwise 'de'
	const lang = document.documentElement.lang || 'de';
	return tranlations[key] && tranlations[key][lang] || key;
}

